import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MessageCircle, Loader, ChevronLeft, ChevronRight, Search } from 'lucide-react';
import useApi from "../../utils/useApi";
import Button from "../UI/Button";
import avatar from "../../assets/avatar.png"
import {useNavVisibility} from "../NavVisibilityContext/NavVisibilityContext";
import ClientSelectSearch from "../Admin/ClientSelectSearch/ClientSelectSearch";

export function Messages({user, handleShowSettingsHeader, handleShowHeader}) {
    const {fetchThreads, createThread, searchThreads, searchClients, fetchMessageAdmins} = useApi();
    const [userId, setUserId] = useState(user.id);
    const [admin, setAdmin] = useState(null);
    const [threadsData, setThreadsData] = useState(null);
    const [messageAdmins, setMessageAdmins] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectUser, setSelectUser] = useState(false);
    const [userToMessage, setUserToMessage] = useState(null);
    const [clients, setClients] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const navigate = useNavigate();
    const { setIsNavVisible } = useNavVisibility();

    useEffect(() => {
        handleShowHeader(true);
        handleShowSettingsHeader(false);
      //  initializeMessages();
        initializeClientSearch();
        setIsNavVisible(true);

        if(user.id === 1){
            getMessageCounts();
        }
    }, []);

    useEffect(() => {
        initializeMessages(userId);

    }, [userId]);

    const getMessageCounts = async () => {
        const response = await fetchMessageAdmins();

        setMessageAdmins(response);
    }


    const initializeMessages = async () => {
        setIsLoading(true);
        try {
            const response = await fetchThreads(userId, 1);

            setThreadsData(response.threads);
            setCurrentPage(response.threads.current_page);
        } catch (error) {
            console.error('Error fetching threads:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const initializeClientSearch = async () => {
        const response = await searchClients({ term: '' });
        setClients(response.clients.filter(user => user.user_type === 'client'));
        setAdmins(response.admins || response.clients.filter(user => user.user_type === 'admin'));
    }

    const handleSearch = async (e) => {
        const term = e.target.value;
        setSearchTerm(term);

        if (term.length === 0) {
            setIsSearching(false);
            initializeMessages();
            return;
        }

        setIsSearching(true);
        setIsLoading(true);

        try {
            const response = await searchThreads(term);
            setThreadsData(response.threads);
        } catch (error) {
            console.error('Error searching threads:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePageChange = async (pageNumber) => {
        if (pageNumber < 1 || pageNumber > threadsData.last_page) return;

        setIsLoading(true);
        try {
            const response = await fetchThreads(user.id, pageNumber);
            setThreadsData(response.threads);
            setCurrentPage(pageNumber);
        } catch (error) {
            console.error('Error fetching page:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleNewMessage = () => {
        setSelectUser(true);
    }

    const handleUserSelect = (client) => {
        setUserToMessage(client);
        handleGetOrCreateNewMessage(client);
    }

    const handleGetOrCreateNewMessage = async (client) => {;
        let data;
        if(user.user_type === 'admin'){
            data = {
                uid: client.id,
            }
        } else {
            data = {
                adminId: client.id,
            }
        }

        data.newMessage = true;

        const response = await createThread(data);

        navigate(`/messages/${response.thread.id}`);
    }

    const handleAdminSelect = (admin) => {
        console.log(admin);
        setAdmin(admin);
        setUserId(admin.id);
        //handleGetOrCreateNewMessage(admin);
    }

    return (
        <div className="max-w-4xl px-4 mx-auto page-container z-10 relative">
            {/* Sticky Search Bar */}
            <div className="sticky top-0 bg-white dark:bg-gray-800 p-4 shadow-md mb-6 rounded-lg z-20">
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 dark:text-gray-500" />
                    <input
                        type="text"
                        placeholder="Search messages..."
                        value={searchTerm}
                        onChange={handleSearch}
                        className="w-full pl-10 pr-4 py-2 border border-gray-200 dark:border-gray-700 rounded-lg
                                 bg-white dark:bg-gray-700
                                 text-gray-900 dark:text-white
                                 placeholder-gray-500 dark:placeholder-gray-400
                                 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400
                                 transition-colors"
                    />
                </div>
            </div>

            {(user?.id === 1 && messageAdmins.length > 0) && (
                <div className="flex flex-wrap justify-center items-center gap-2 mb-4">
                    {messageAdmins.map((admin) => (
                        <Button
                            key={admin.id}
                            onClick={() => handleAdminSelect(admin)}
                            className="relative"
                        >
                            <span className="flex items-center">
                                <MessageCircle className="w-4 h-4 mr-2" />
                                {admin.profile.client ?? admin.client_id}
                                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                                    {admin.messageCount}
                                </span>
                            </span>
                        </Button>
                    ))}
                </div>
            )}

            <div className="flex justify-between items-center mb-6 p-4 ">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Messages
                    </h1>

                    <p className="text-gray-500 dark:text-gray-400">
                        {admin && (
                            <span>for: {admin.profile.client ?? admin.client_id}</span>
                        )}
                        {!admin && (
                            <span>for: {user?.profile?.client}</span>
                        )}
                    </p>
                </div>
                <div className={`flex flex-col`}>
                    {/* messages/create */}
                    <Button onClick={() => handleNewMessage()}>
                        <MessageCircle className="w-4 h-4 mr-2" />
                        New Message
                    </Button>

                </div>


            </div>
            <div className="flex flex-row">
                {selectUser && user.user_type === 'admin' && (
                    <ClientSelectSearch
                        placeholder={'Select a user to message'}
                        clients={clients}
                        includeLink={false}
                        currentClient={userToMessage}
                        onSelectClient={handleUserSelect}
                    />
                )}
                {selectUser && user.user_type !== 'admin' && (
                    <ClientSelectSearch
                        header={'Search for a preparer'}
                        placeholder={'Select a preparer to message'}
                        clients={admins}
                        includeLink={false}
                        currentClient={userToMessage}
                        onSelectClient={handleUserSelect}
                    />
                )}
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm">
                {isLoading ? (
                    <div className="flex justify-center p-8">
                        <Loader className="w-6 h-6 animate-spin text-gray-500 dark:text-gray-400" />
                    </div>
                ) : threadsData?.data?.length > 0 ? (
                    <>
                        <div className="divide-y divide-gray-200 dark:divide-gray-700">
                            {threadsData.data.map((thread) => (
                                <div
                                    key={thread.id}
                                    onClick={() => navigate(`/messages/${thread.id}`)}
                                    className={`p-4 cursor-pointer  transition-colors ${thread.unread ? 'bg-blue-400 dark:hover:bg-gray-900 hover:bg-blue-600':'hover:bg-gray-50 dark:hover:bg-gray-700' }`}
                                >
                                    <div className="flex items-center space-x-4">
                                        <img
                                            src={avatar || '/api/placeholder/40/40'}
                                            alt="Avatar"
                                            className="w-10 h-10 rounded-full"
                                        />
                                        <div className="flex-1 min-w-0">
                                            <p className={`text-sm truncate md:max-w-md max-w-xs  ${thread.unread ? 'font-bold text-white':'font-medium text-gray-900 dark:text-white'}`}>
                                                {thread.string}
                                            </p>
                                            <div className="flex justify-between items-center">
                                                <div className="flex flex-col">
                                                    <p className={`text-sm  md:max-w-md max-w-xs ${thread.unread ? ' font-bold text-white' : 'text-gray-500 dark:text-gray-400 font-medium'}`}
                                                    style={{maxWidth: "14rem", marginBottom: "3px"}}
                                                    >
                                                        {thread.subject}
                                                    </p>
                                                    <p className={`text-sm ${thread.unread ? ' font-medium text-white' : 'text-gray-500 dark:text-gray-400'}`}>{thread.latestMessage ? thread.latestMessage : ''}</p>
                                                </div>

                                                <p className={`text-xs text-right
                                                ${thread.unread ? 'font-bold text-white' : 'text-gray-400 dark:text-gray-500'}`}
                                                   dangerouslySetInnerHTML={{ __html: thread.humanDate }}
                                                >
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Only show pagination when not searching */}
                        {!isSearching && threadsData.per_page < threadsData.total && (
                            <div className="flex items-center justify-between p-4 border-t border-gray-200 dark:border-gray-700">
                                <Button
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    className="flex items-center"
                                >
                                    <ChevronLeft className="w-4 h-4 mr-2" />
                                    Previous
                                </Button>
                                <span className="text-sm text-gray-500 dark:text-gray-400">
                                    Page {currentPage} of {threadsData.last_page}
                                </span>
                                <Button
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === threadsData.last_page}
                                    className="flex items-center"
                                >
                                    Next
                                    <ChevronRight className="w-4 h-4 ml-2" />
                                </Button>
                            </div>
                        )}
                    </>
                ) : (
                        <div className="p-8 text-center text-gray-500 dark:text-gray-400">
                            {searchTerm ? 'No messages found matching your search' : 'No messages found'}
                        </div>
                    )}
            </div>
        </div>
    );
}

export default Messages;
